var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from 'react';
import Logger from '@cvent/nucleus-logging';
var LOG = new Logger('eventWidget/AppleMapWrapper');
var AppleMapWrapper = /** @class */ (function (_super) {
    __extends(AppleMapWrapper, _super);
    function AppleMapWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            appleMapkitReady: false
        };
        _this.initMap = function (appleMapToken) {
            window.mapkit.init({
                authorizationCallback: function (done) {
                    done(appleMapToken);
                }
            });
            _this.setState({ appleMapkitReady: true });
        };
        return _this;
    }
    AppleMapWrapper.prototype.componentDidMount = function () {
        var _this = this;
        var appleMapToken = this.props.appleMapToken;
        loadMapkit().then(function () { return _this.initMap(appleMapToken); });
    };
    AppleMapWrapper.prototype.render = function () {
        if (!this.state.appleMapkitReady)
            return null;
        return React.createElement(Fragment, null, this.props.children);
    };
    return AppleMapWrapper;
}(Component));
export { AppleMapWrapper };
var loadMapkitPromise;
function loadMapkit() {
    if (!loadMapkitPromise) {
        loadMapkitPromise = new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.src = 'https://cdn.apple-mapkit.com/mk/5.45.0/mapkit.js';
            script.id = 'appleMapkit';
            document.body.appendChild(script);
            // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            script.onload = function () { return resolve(); };
            script.onerror = function (evt) {
                LOG.error('error loading apple mapkit.', evt);
                reject();
            };
        });
    }
    return loadMapkitPromise;
}
